import { AssignedWorkflowTemplateResponse } from '../models/Workflows';
import { QTask, QTaskTag, TaskStatus, TaskPriority } from '@qwealth/qdata';

const createTaskTag = (key: string): QTaskTag => ({
  partnerId: 99,
  key,
});

const createTask = (
  id: number,
  title: string,
  details: string,
  status: TaskStatus,
  priority: TaskPriority,
  dueDate: string | null,
  taskTags: QTaskTag[],
  workflowId: string,
  workflowName: string,
  workflowGroup: number,
  workflowTags: QTaskTag[],
  taskTemplateId: number,
): QTask => ({
  id,
  assignee: 'janine@qwealth.com',
  householdQID: 'QW-QW-2-001012',
  dueDate,
  title,
  details,
  isInternal: 0,
  partnerID: 99,
  status,
  priority,
  householdName: 'Test, Janine',
  householdType: 'Regular',
  householdIaCode: 'QWMP',
  taskTags,
  lastUpdatedBy: 'janine@qwealth.com',
  createdBy: 'janine@qwealth.com',
  lastUpdated: '2025-12-15T10:00:00Z',
  startTime: '2025-12-01T09:00:00Z',
  // workflowId,
  // workflowName,
  // workflowGroup,
  // workflowTags,
  // taskTemplateId,
  taskType: 'Standard',
});

export const mockAssignedWorkflowResponse: AssignedWorkflowTemplateResponse[] = [
  // Workflow 1: Simple - 1 group, 1 task
  {
    // uuid: 'workflow-001',
    // householdQID: 'QW-QW-2-001012',
    // householdName: 'Test, Janine',
    // householdType: 'Regular',
    // name: 'Client Onboarding',
    // taskTags: [createTaskTag('action'), createTaskTag('Bla2')],
    // description:
    //   'What is Lorem Ipsum Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.',
    // currentDueDate: '2025-12-20',
    // status: 'In Progress' as WorkflowStatus,
    tasks: [
      createTask(
        1111,
        'Complete KYC Documentation',
        'Collect and verify all Know Your Customer documentation',
        'In Progress',
        'High',
        '2025-12-20',
        [],
        'workflow-001',
        'Client Onboarding',
        0,
        [createTaskTag('action'), createTaskTag('Bla2')],
        1,
      ),
    ],
  },

  // Workflow 2: 2 groups with varying tasks
  {
    tasks: [
      createTask(
        2222,
        'Gather Financial Statements',
        'Collect all financial statements from the past year',
        'Not Started',
        'High',
        '2025-12-22',
        [createTaskTag('Bla2')],
        'workflow-002',
        'Annual Review Process',
        0,
        [createTaskTag('Cats'), createTaskTag('hammertime3')],
        10,
      ),
      createTask(
        3333,
        'Review Investment Performance',
        'Analyze portfolio performance against benchmarks',
        'Not Started',
        'High',
        '2025-12-25',
        [createTaskTag('action')],
        'workflow-002',
        'Annual Review Process',
        0,
        [createTaskTag('Cats'), createTaskTag('hammertime3')],
        12,
      ),

      createTask(
        4444,
        'Schedule Review Meeting',
        'Book meeting with client to discuss findings',
        'Not Started',
        'Medium',
        '2025-12-28',
        [createTaskTag('Bla2')],
        'workflow-002',
        'Annual Review Process',
        1,
        [createTaskTag('Cats'), createTaskTag('hammertime3')],
        1,
      ),
      createTask(
        5555,
        'Prepare Review Report',
        'Create comprehensive annual review report',
        'Not Started',
        'High',
        '2025-12-31',
        [],
        'workflow-002',
        'Annual Review Process',
        1,
        [createTaskTag('Cats'), createTaskTag('hammertime3')],
        10,
      ),
      createTask(
        6666,
        'Update Client Portal',
        'Upload all relevant documents to client portal',
        'Not Started',
        'Low',
        '2025-12-31',
        [],
        'workflow-002',
        'Annual Review Process',
        1,
        [createTaskTag('Cats'), createTaskTag('hammertime3')],
        12,
      ),
    ],
  },
];
